if (!process.env.VUE_APP_IS_WEB) {
  var remoteTableDB = require("./models/RemoteDB");
}

import axios from "axios";
import sync from "@/database/sync";
import links from "@/links/links";

const dataFromTables = [
  "Building",
  "BuildingLot",
  "BuildingOwner",
  "BuildingOwnerBuildingLot",
  "BuildingOwnerVotingRight",
  "Contact",
  "Majority",
  "Mandate",
  "Media",
  "Meeting",
  "MeetingGuest",
  "MeetingResolution",
  "Resolution",
  "ResolutionCatalog",
  "ResolutionCatalogTag",
  "ResolutionVote",
  "Tag",
  "VotingCategory",
];

export default {
  initLocalTables() {
    return new Promise((resolve, reject) => {
      new remoteTableDB()
        .fetchAll()
        .then(res => {
          let initAlreadyDone = false;
          if (res.serialize()[0]) initAlreadyDone = true;
          resolve(initAlreadyDone);
        })
        .catch(err => {
          console.log("err", err);
          reject(err);
        });
    }).then(initAlreadyDone => {
      if (!initAlreadyDone) {
        dataFromTables.forEach(async table => {
          // format init object
          // "done" types:
          //    0 - process to get the remote DB not started
          //    1 - process to get the remote DB in progress
          //    2 - process to get the remote DB done
          let initTableObject = { table: table, done: 0 };
          let formatObjectItem = JSON.parse(JSON.stringify(initTableObject));
          await new remoteTableDB(formatObjectItem).save().catch(err => {
            console.log("err", err);
          });
        });
      }
    });
  },
  // set table to status
  setLocalTableStatus(entityName, status) {
    return new Promise((resolve, reject) => {
      let statusTableObject = { table: entityName, done: status };
      let formatObjectItem = JSON.parse(JSON.stringify(statusTableObject));
      new remoteTableDB(formatObjectItem)
        .where({ table: entityName })
        .upsert()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log("err", err);
          reject(err);
        });
    });
  },
  // get table to status
  getLocalTableStatus(entityName) {
    return new Promise((resolve, reject) => {
      new remoteTableDB()
        .where({ table: entityName })
        .fetch()
        .then(res => {
          let tableObj = res.serialize();
          resolve(tableObj.done);
        })
        .catch(err => {
          console.log("err", err);
          reject(err);
        });
    });
  },
  // get remote db
  getRemoteDB(entityName, link) {
    return new Promise((resolve, reject) => {
      axios
        .get(link)
        .then(async res => {
          let objectsFromRemote = res.data["hydra:member"];

          if (entityName == "Media") {
            // split array in chunks of 10
            // get media with file_path and file_as_base64_string from web (in for loop)
            // then use function to write files in desktop

            let chunkMediaArray = this.chunkMediaArray(objectsFromRemote, 10);

            for (const chunkOfMedia of chunkMediaArray) {
              let filesFromWeb = [];

              await axios
                .post(links.MEDIA_GET_FILES(), {
                  items: chunkOfMedia,
                })
                .then(res => {
                  filesFromWeb = res.data["hydra:member"];
                })
                .catch(err => {
                  console.error(err);
                });

              if (filesFromWeb) {
                filesFromWeb.forEach(file => {
                  sync.writeFileFromBase64String(file);
                });
              }
            }
          }

          for (let i = 0; i < objectsFromRemote.length; i++) {
            var tableModel = require(`./models/${entityName}`);
            // console.log("OBJ", objectsFromRemote[i]);
            await new tableModel(objectsFromRemote[i])
              .save(null, { method: "insert", ignoreEntitySync: true })
              .catch(err => {
                console.error("err", err);
                reject(err);
              });
          }

          resolve("done");
        })
        .catch(err => {
          console.error("err", err);
          reject(err);
        });
    });
  },
  chunkMediaArray(myArray, chunkSize) {
    var arrayLength = myArray.length;
    var tempArray = [];

    for (var index = 0; index < arrayLength; index += chunkSize) {
      let myChunk = myArray.slice(index, index + chunkSize);
      let processedChunk = [];

      myChunk.forEach(item => {
        processedChunk.push({
          id: item.id,
          file_path: item.file_path,
        });
      });

      tempArray.push(processedChunk);
    }

    return tempArray;
  },
};
